import { configureStore } from '@reduxjs/toolkit';

import { environment } from '../../environments/environment';
import { rehydrateAuthAction } from 'features/auth/ducks';

import { middleware } from './listener-middleware';
import { loadPersistedAuth } from './persistence';
import rootReducer from './root-reducer';

// Import ducks to register listeners at module load
import 'features/auth/ducks';
import 'features/home/features/forms/ducks';
import 'features/form/ducks';
import 'features/form/features/verification/ducks';
import 'features/form/features/transaction/ducks';
import 'features/form/features/transaction/features/verification-log/ducks';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(middleware),
});

async function initStore() {
  const persisted = await loadPersistedAuth();
  if (persisted) {
    store.dispatch(rehydrateAuthAction(persisted));
  }
  return store;
}

if (environment.debug) {
  (window as any).store = store;
}

export { initStore, store };
